import Popup from "../User/popup";
import SignIn from "../User/signIn";
import SignUp from "../User/signUp";
import ResetPassword from "../User/resetPassword";
import LoginValidation from "../User/loginValidation";
import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
function Registrationpup({
    displaypup = false, handlePopupStatusChange, redirectURL
}) {
    const { t: trans, i18n } = useTranslation(["common", "form", "language", "info", "home"]);
    let lang = (i18n.language || 'ar').toLowerCase().slice(0, 2);
    const languageDir = "language-" + lang;
    const [showPopup, setShowPopup] = useState(false);
    const [activePopUpModel, setActivePopUpModel] = useState({
        tab: 1,
        title: 'sign-in'
    });
    const handlePopupStatus = (status) => {
        setShowPopup(status);
        handlePopupStatusChange(status);
    };

    const handleTabChange = (tab) => {
        console.log('New tab is', tab);
        setActivePopUpModel(tab);
    };


    useEffect(() => {
        setShowPopup(displaypup);
    }, [displaypup]);

    return (
        <Popup show={showPopup}>
            <div className="custom-popup-wrapper" onClick={(e) => {
                if (e.target === e.currentTarget) handlePopupStatus(false);
            }}>
                <div className="custom-popup-container">
                    {/* Image & Brand Side */}
                    <div className={`custom-popup-image-side ${languageDir}`} style={{ backgroundImage: "url('/assets/images/bg-hj.png')" }}>
                        {lang === "ar" ? (
                            <img src="/assets/logo/logo_AR.png" alt="logo" className="custom-popup-logo" />
                        ) : (
                            <img src="/assets/logo/logo_EN.png" alt="logo" className="custom-popup-logo" />
                        )}

                        <div className="custom-popup-image-content-overlay" key={activePopUpModel.tab}>
                            <h2>
                                {activePopUpModel.tab == 1 ? (lang === 'ar' ? 'مرحباً بك' : 'Welcome Back') :
                                    activePopUpModel.tab == 2 ? (lang === 'ar' ? 'إنشاء حساب جديد' : 'Create Account') :
                                        activePopUpModel.tab == 3 ? (lang === 'ar' ? 'نسيت كلمة المرور' : 'Reset Password') :
                                            (lang === 'ar' ? 'التحقق' : 'Validation')}
                            </h2>
                            <p>
                                {activePopUpModel.tab == 1 ? (lang === 'ar' ? 'سجّل دخولك لمتابعة استخدام حسابك' : 'Sign in to continue to your account') :
                                    activePopUpModel.tab == 2 ? (lang === 'ar' ? 'انضم إلينا اليوم للحصول على أفضل الخدمات' : 'Join us today to get the best services') :
                                        activePopUpModel.tab == 3 ? (lang === 'ar' ? 'أدخل بياناتك لاستعادة الوصول لحسابك' : 'Enter your details to regain access') :
                                            (lang === 'ar' ? 'مرحباً بك مجدداً' : 'Welcome back again')}
                            </p>
                        </div>

                        {/* Curvy shape separating the two sides */}
                        <svg
                            className="custom-curve-svg"
                            viewBox="0 0 100 100"
                            preserveAspectRatio="none"
                        >
                            <path d="M100,0 C30,30 30,70 100,100 Z" />
                        </svg>
                    </div>

                    {/* Form Side */}
                    <div className={`custom-popup-form-side ${languageDir}`}>
                        <div className="custom-popup-close-btn" onClick={() => handlePopupStatus(false)}>
                            <svg viewBox="0 0 512 512" fill="currentColor" height="2rem" width="2rem">
                                <path fill="none" stroke="currentColor" strokeMiterlimit={10} strokeWidth={32} d="M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z" />
                                <path fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={32} d="M320 320L192 192M192 320l128-128" />
                            </svg>
                        </div>

                        <div className="custom-popup-top-tabs">
                            <button
                                className={activePopUpModel.tab == 1 ? 'active' : ''}
                                onClick={() => handleTabChange({ tab: 1, title: 'sign-in' })}
                            >
                                {trans("form:sign-in")}
                            </button>
                            <button
                                className={activePopUpModel.tab == 2 ? 'active' : ''}
                                onClick={() => handleTabChange({ tab: 2, title: 'sign-up' })}
                            >
                                {trans("form:sign-up")}
                            </button>
                        </div>

                        <div className="custom-popup-scroll">
                            {activePopUpModel.tab == 1 ? (
                                <SignIn
                                    onTabChange={(tab) => handleTabChange(tab)}
                                    onLogin={() => handlePopupStatus(false)}
                                    redirectURL={redirectURL}
                                />
                            ) : activePopUpModel.tab == 2 ? (
                                <SignUp
                                    onTabChange={(tab) => handleTabChange(tab)}
                                    onLogin={() => handlePopupStatus(false)}
                                />
                            ) : activePopUpModel.tab == 3 ? (
                                <ResetPassword
                                    onTabChange={(tab) => handleTabChange(tab)}
                                />
                            ) : (
                                <LoginValidation
                                    onTabChange={(tab) => handleTabChange(tab)}
                                    onLogin={() => handlePopupStatus(false)}
                                />
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </Popup>
    )
}

export default Registrationpup;